import {
  ADD_WALLET,
  DELETE_WALLET,
  GET_ALL_WALLET,
  UPDATE_WALLET,
  UPDATE_STATUS_WALLET,
  GET_BALANCE,
} from "../types";

const initialState = { list: [], single: null, balance: null };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // ===============================
    // 👉 GET ALL WALLETS
    // ===============================
    case GET_ALL_WALLET:
      return { ...state, list: payload };

    // ===============================
    // 👉 GET BALANCE
    // ===============================
    case GET_BALANCE:
      return { ...state, balance: payload };

    // ===============================
    // 👉 UPDATE WALLET
    // ===============================
    case UPDATE_WALLET:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    // ===============================
    // 👉 UPDATE WALLET STATUS
    // ===============================
    case UPDATE_STATUS_WALLET:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    // ===============================
    // 👉 ADD WALLET
    // ===============================
    case ADD_WALLET:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    // ===============================
    // 👉 DELETE WALLET
    // ===============================
    case DELETE_WALLET:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };

    default:
      return state;
  }
};

export default reducer;
